import { TStrapiV4TestimonialCard } from '../../common-types'
import { RatingStars } from '../../atoms-components/rating-star/StrapiV4RatingStar'
import Text from '@/stories/components/Common/NewText'
import { StencilCDNImage } from '@/components/Common/StencilImage'

const TestimonialCard = (props: TStrapiV4TestimonialCard) => {
  const { title, author, description, date, rating } = props
  return (
    <div className="lg:min-w-1/3 w-full min-w-full lg:min-h-[280px] lg:w-1/3 ">
      <div className="bg-brand-grey-background mx-3 flex h-full flex-col rounded-3xl">
        <section className="mb-4 mt-3 px-4 text-left">
          <RatingStars
            fullStars={Math.floor(rating ?? 0)}
            hasHalfStar={(rating ?? 0) % 1 === 0.5}
          />
        </section>
        <section className="flex-grow px-4 text-left">
          <Text appearance="heading2" addClassName="leading-relaxed mb-2">
            {title}
          </Text>
          <Text
            appearance="caption"
            addClassName="text-brand-grey-base leading-relaxed text-sm mb-2"
          >
            {description}
          </Text>
        </section>
        <div
          className="mt-auto flex flex-row justify-between px-4 pb-4"
          id="bottom-data"
        >
          <div>
            <Text
              appearance="caption"
              addClassName="font-medium text-sm leading-relaxed"
            >
              {author}
            </Text>
            <Text
              appearance="caption"
              addClassName="text-brand-grey-base text-13px leading-relaxed"
            >
              {date}
            </Text>
          </div>
          <div className="flex items-end justify-end">
            <StencilCDNImage
              loading="eager"
              src="https://indcdn.indmoney.com/cdn/images/fe/testimonial_icon.png"
              height={60}
              width={60}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default TestimonialCard
